import BaseStore from './BaseStore';
import DataOriginParameterTemplateModel from "../models/DataOriginParameterTemplateModel";

export default class DataOriginParameterTemplateStore extends BaseStore {
  constructor(transportLayer) {
    super(DataOriginParameterTemplateModel, transportLayer);
  }
};


// WEBPACK FOOTER //
// ./src/stores/DataOriginParameterTemplateStore.js